var inlineNotificationI18n = {
  close: 'close'
};
export default inlineNotificationI18n;